import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames/bind';

import ContentBlocks from 'components/ContentBlocks/ContentBlocks';
import DeepDive from 'components/DeepDive/DeepDive';
import localize from 'components/Localize/Localize';

import styles from './EvaluateProducts.css';
import translations from './translations';

const cx = classNames.bind(styles);

class EvaluateProducts extends React.Component {
  render() {
    const containerClass = cx(`deepdive-container`, {
      [this.props.containerStyles]: this.props.containerStyles,
    });

    return (
      <DeepDive
        containerStyles={containerClass}
        englishPromptText={translations[`en-US`].promptText}
        t={this.props.t}
      >
        <ContentBlocks
          blocks={this.props.t.blocks}
          imageContainerStyles={styles[`deepdive-image-container`]}
        />
      </DeepDive>
    );
  }
}

EvaluateProducts.propTypes = {
  containerStyles: PropTypes.string,
  t: PropTypes.shape({
    blocks: PropTypes.arrayOf(PropTypes.shape({
      content: PropTypes.string.isRequired,
      heading: PropTypes.string.isRequired,
      imageAlt: PropTypes.string,
      imagePath: PropTypes.string.isRequired,
    })).isRequired,
    blocksHeading: PropTypes.string.isRequired,
    promptText: PropTypes.string.isRequired,
  }).isRequired,
};

export default localize(EvaluateProducts, translations);
